import React from "react";
import YouTube from "react-youtube";

const videoID = "Fm5iP0S1z9w";
const options = {
  playerVars: {
    rel: 0,
    controls: 0,
    showinfo: 0,
    autoplay: 1,
    loop: 1,
    end: 245,
    playlist: videoID,
    mute: 1,
    cc_load_policy: 3,
  }
};

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
    };

    this.handlePlay = this.handlePlay.bind(this);
  }

  handlePlay() {
    return this.setState({isPlaying: true});
  }

  render() {
    const {isPlaying} = this.state;
    return (
      <div className="landing-bg">
        <div className="indexBackground backgroundImage" />
        <YouTube
          videoId={videoID}
          opts={options}
          onPlay={this.handlePlay}
          className={`yt-background ${isPlaying ? "bg-fadein" : ""}`}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/VideoBackground/index.jsx